import { render } from "./SidebarWms.vue?vue&type=template&id=720bf000&scoped=true&ts=true"
import script from "./SidebarWms.vue?vue&type=script&lang=ts"
export * from "./SidebarWms.vue?vue&type=script&lang=ts"

import "./SidebarWms.vue?vue&type=style&index=0&id=720bf000&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720bf000"]])

export default __exports__